import Sentry from '../errors/sentry';

const REDIRECT_STORAGE_KEY = 'redirectAfterLoginTo';

export const redirectAfterLogin = (router, authPopupStore) => {
	const name = localStorage.getItem(REDIRECT_STORAGE_KEY);

	authPopupStore.hideShowAuthPopup();

	if (name == null) {
		router.go();
		return;
	}

	if (!router.hasRoute(name)) {
		Sentry.captureMessage('auth-popup: invalid redirect route', {
			level: 'warning',
			tags: { area: 'auth-popup' },
			extra: { name },
		});
		router.go();
		return;
	}

	router.push({ name }).catch((error) => {
		Sentry.captureException(error, {
			tags: { area: 'auth-popup', phase: 'redirect' },
			extra: { name },
		});
		router.go();
	});
};
